import { Outlet, useLocation } from "react-router-dom";
import { useStore } from "../../context/StoreContext";
import { waLink } from "../../lib/whatsapp";
import Header from "./Header";
import Footer from "./Footer";
import SelectionDrawer from "./SelectionDrawer";
import WelcomeGate from "./WelcomeGate";
import { WhatsAppIcon } from "./WhatsAppIcon";

export default function PublicLayout() {
  const { hasAccess, settings } = useStore();
  const { pathname } = useLocation();

  if (!hasAccess && pathname !== "/privacidade") return <WelcomeGate />;

  return (
    <div className="flex min-h-screen flex-col bg-[#0B0B0C] text-[#FAF6F0]">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <SelectionDrawer />
      {settings?.whatsapp && (
        <a href={waLink(settings.whatsapp, "Olá! Gostaria de mais informações sobre os perfumes da EMAIA PERFUMES.")} target="_blank" rel="noopener noreferrer"
          className="fixed bottom-5 right-5 z-30 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.4)] transition-transform hover:scale-105"
          aria-label="Falar no WhatsApp" data-testid="floating-whatsapp-button">
          <WhatsAppIcon className="h-7 w-7" />
        </a>
      )}
    </div>
  );
}
